import { Injectable } from '@angular/core';
import { HttpService } from '@sdbn/appclient';
import { Observable } from 'rxjs';
import { Pager } from '../model/pager';
import { environment } from 'src/environments/environment';
import { Identity } from '@sdbn/appclient';
import { PagerDetails } from '../model/pager-details';
import { ServiceResponse } from '@sdbn/appclient';

@Injectable({
    providedIn: 'root'
  })
  export class PagereService {

    constructor(private tmcHttpService: HttpService) { }

    getPagers(): Observable<Pager[]> {
      return this.tmcHttpService.postWithContext<Pager[]>(environment.pagerAdminEndpoint, {});
    }

    getPagerDetails(identity: Identity): Observable<PagerDetails> {
      return this.tmcHttpService.postWithContext<PagerDetails>(environment.pagerAdminEndpoint + '/details', identity);
    }

    savePager(smartphone: PagerDetails): Observable<ServiceResponse> {
      return this.tmcHttpService.postWithContext<ServiceResponse>(environment.pagerAdminEndpoint + '/save', smartphone);
    }

    createPager(smartphone: PagerDetails): Observable<ServiceResponse> {
      return this.tmcHttpService.postWithContext<ServiceResponse>(environment.pagerAdminEndpoint + '/create', smartphone);
    }

    deletePager(identity: Identity): Observable<ServiceResponse> {
      return this.tmcHttpService.postWithContext<ServiceResponse>(environment.pagerAdminEndpoint + '/delete', identity);
    }
  }
